import useGoalInfo from '@api/hooks/goal/useGoalInfo';

const useIsRecordedGoal = (goalUID) => {
  const { goalInfo } = useGoalInfo(goalUID);

  return !!goalInfo?.isRecordedGoal;
};

export default useIsRecordedGoal;
